import React from 'react'
import { ContactForm } from './contactForm'
import { Container, Row, Col } from "react-bootstrap";

/**
* @author
* @function ContactPage
**/

export const ContactPage = (props) => {
  return(
    <Container className="my-5 joint-venture-page">
        <Row className="text-center mb-5">
            <Col>
              <p className="fw-bold">CONTACT US</p>
              <h3 className="fw-bold font-red">
                Let’s begin a trusted conversation
              </h3>        
            </Col>
        </Row>
        <ContactForm/>
    </Container>
   )
  }
